import types from '../constants/actionTypes';

export default function webhookReducer (state = {}, action) {
  if (action.type === types.SELECT_WEBHOOK) {
    const newState = Object.assign({}, state, { currentWebhookId: action.id, currentDomainId: action.domainId });
    return newState;
  }
  return state;
}
